/**
 * Representation of the Timeline Entity
 * 
 * @author Leander Eyer <leander.eyer@elead.ch>
 */

export { Timeline };

import {TimelineEntry} from './TimelineEntry.js'

class Timeline {

	constructor(model, data) {

		// Properties
		this.model = model;
		this.id = data.id;
		this.isActive = data.isActive;
		this.nameDE = data.nameDE != null? data.nameDE.trim() : "";
		this.nameEN = data.nameEN != null? data.nameEN.trim() : "";
		this.nameFR = data.nameFR != null? data.nameFR.trim() : "";

		this.textDE = data.textDE != null? data.textDE.trim() : "";
		this.textEN = data.textEN != null? data.textEN.trim() : "";
		this.textFR = data.textFR != null? data.textFR.trim() : "";

		this.fileDE = data.fileDE != null? data.fileDE.trim() : "";
		this.fileDE = this.fileDE != ""? JSON.parse(this.fileDE) : null;
		this.fileEN = data.fileEN != null? data.fileEN.trim() : "";
		this.fileEN = this.fileEN != ""? JSON.parse(this.fileEN) : null;
		this.fileFR = data.fileFR != null? data.fileFR.trim() : "";
		this.fileFR = this.fileFR != ""? JSON.parse(this.fileFR) : null;

		this.hideYearBar = data.hideYearBar;

		this.timelineWidth = 0;

		// Relations
		this.works = [];
	}
	
	// Basic Getters
	
	getID() {
		return this.id;
	}
	
	getActive() {
		return this.isActive == 1;
	}

	getArchive() {
		return this.isActive == 2;
	}

	getName() {
		if (this.model.getLang() == 'en') {
			return this.nameEN;
		} else if (this.model.getLang() == 'fr') {
			return this.nameFR;
		} else {
			return this.nameDE;
		}
	}
	
	getHideYearBar() {
		return this.hideYearBar;
	}

	getText() {
		if (this.model.getLang() == 'en') {
			return this.textEN;
		} else if (this.model.getLang() == 'fr') {
			return this.textFR;
		} else {
			return this.textDE;
		}
	}
	
	getFile() {
		if (this.model.getLang() == 'en') {
			return this.fileEN;
		} else if (this.model.getLang() == 'fr') {
			return this.fileFR;
		} else {
			return this.fileDE;
		}
	}

	getImage() {
		
		// use the first work iamge
		for (let i = 0; i < this.works.length; i++) {
			if (this.works [i].getWork().getImages().hasImages()) {
				return this.works [i].getWork().getImages();
			}
		}
		
		return null;
	}
	
	getWidth() {
		return this.timelineWidth;
	}

	// sort the timeline and annotate it
	sortAndAnotate() {
		this.works.sort(function(a,b) {
			return a.work.sortYear - b.work.sortYear;
		});

		let centuryFormatCounter = -1;
		let centuryCache = 0;
		for (let i = 0; i < this.works.length; i++) {
			// build the century borders and colorization
			let centuryCursor = this.works [i].work.getYear().substring(0, 2);
			if (centuryCursor != centuryCache) {
				this.works [i].setLabel((parseInt(centuryCursor) + 1) + ". Jh.");
				centuryCache = centuryCursor;
				centuryFormatCounter++;
			}
			this.works [i].setFormat("century-" + centuryFormatCounter);
			
			// calculate the width of the hole timeline in REM
			this.timelineWidth += 9 / this.works [i].getWork().getPrimaryImageAspectRatio();
		}	
	}

	// Relations
	
	getWorks() {
		return this.works;
	}
	
	addWork(work) {
		this.works.push(new TimelineEntry(work));
	}

	// Utilities

	/** Get the basic (unencoded) URL Term form for this entity */
	getURLTerm() {
		return this.nameDE.trim().replace(/ /g, "_").toLowerCase();		
	}

	/** Equality Test Used for URL Resovling */
	acceptURLTerm(term) {
		return this.getURLTerm() == term;
	}
	
}